export const FEE_PERCENT = 2.9;
export const FEE_FIXED = 0.35;
